const Cards = {
  baseStyle: {
    container: {
      bg: "white",
      borderRadius: "md",
      boxShadow: "lg",
    },
    header: {
      p: 4,
    },
    body: {
      p: 4,
    },
    footer: {
      p: 4,
    },
  },
  variants: {
    panel: {
      container: {
        bg: "white",
        borderRadius: "md",
        boxShadow: "lg",
        overflow: "hidden",
      },
    },
    dataset: {
      container: {
        bg: "Gray.100",
        borderRadius: "md",
        boxShadow: "md",
        overflow: "hidden",
      },
      header: {
        bg: "Gray.200",
        p: 3,
      },
      body: {
        p: 4,
      },
    },
  },
}

export default Cards
